import React, { useState } from 'react'
import Colors from 'colors.json'
import { Form, Formik } from 'formik'

import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DatetimePickerInput from 'components/DatetimePickerInput'
import Input from 'components/Input'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { CreateMerchantDeviceSchemas } from 'schemas/createMerchantDeviceSchemas'
import { useCreateDevice } from './useCreateDevice'
import { useMerchantDeviceTypes } from '../../Tabs/Device/useMerchantDeviceTypes'

const Index: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  // STATES
  const { merchantDeviceTypesOptions, merchantDeviceTypesModStatus } =
    useMerchantDeviceTypes()
  const { isLoading, initialValues, handleSubmitCreateMerchantDevice } =
    useCreateDevice(onCloseModal)

  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  if (isLoading) return <></>

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={CreateMerchantDeviceSchemas}
      onSubmit={handleSubmitCreateMerchantDevice}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => {
        return (
          <Form className="flex flex-col">
            <div className="mb-4 ">
              <div className="gap-4 items-center">
                <div className="flex gap-4 items-center">
                  <Input
                    name="deviceCode"
                    label="Device Code"
                    containerClassName="w-full"
                    type="number"
                  />
                </div>
                <Dropdown
                  title="Device Types"
                  options={merchantDeviceTypesOptions}
                  className="w-full tracking-wider mb-4"
                  borderColor="#C4C4C4"
                  onSelect={(data) =>
                    setFieldValue('deviceTypeId', String(data.value))
                  }
                />
              </div>
              <div className="flex gap-4 justify-between">
                <DatetimePickerInput
                  title={'Start Date'}
                  setFieldName="startDate"
                  setFieldValue={setFieldValue}
                  showTimeSelect={false}
                  scrollableYearDropdown={true}
                />
                <DatetimePickerInput
                  title={'End Date'}
                  setFieldName="endDate"
                  setFieldValue={setFieldValue}
                  showTimeSelect={false}
                  scrollableYearDropdown={true}
                />
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <Input
                name="comments"
                label="Comment"
                containerClassName="w-full"
                type="input"
              />
            </div>
            <div className="flex gap-4 items-center mb-5">
              <div className="w-full">
                <label
                  htmlFor="username"
                  className="block mb-2 text-sm font-medium text-gray-500"
                >
                  Device Username (optional)
                </label>
                <input
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="off"
                  className="block w-full p-2 text-black tracking-wider border border-gray-600 focus:border-primary"
                  onSelect={(data) =>
                    setFieldValue('username', (data.target as HTMLInputElement).value)
                  }
                />
              </div>
            </div>
            <div className="relative mb-5">
              <div className="w-full">
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-500"
                >
                  Device Password (optional)
                </label>
                <input
                  id="password"
                  name="password"
                  type="text"
                  autoComplete="off"
                  className="block w-full p-2 text-black tracking-wider border border-gray-600 focus:border-primary"
                  style={{
                    ...(!showPassword ? { WebkitTextSecurity: 'disc', fontFamily: 'text-security-disc' } : {})
                  } as React.CSSProperties}
                  onSelect={(data) =>
                    setFieldValue('password', (data.target as HTMLInputElement).value)
                  }
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute right-3 text-gray-500"
                  style={{ top: '2.3rem' }}
                  aria-label="Toggle password visibility"
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>
            <footer className="flex justify-end pb-4 pl-4 pr-0">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Submit</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
